import { ChecklistItemRow, ChecklistItemRowUIConfig } from "./ChecklistItemRow";
import { Sortable, SortableContent, SortableItem } from "@/modern/components/ui/sortable";
import React, { useEffect } from "react";
import { useEntityChecklistContext } from "../context/EntityChecklistContext";
import type { ChecklistItem } from "../types";

interface ChecklistItemListProps {
  checklistItems: ChecklistItem[];
  uiConfig?: ChecklistItemRowUIConfig;
}

export const ChecklistItemList = ({ checklistItems, uiConfig = {} }: ChecklistItemListProps) => {
  const { reorderChecklistItems } = useEntityChecklistContext();
  const [items, setItems] = React.useState<ChecklistItem[]>(checklistItems);

  useEffect(() => {
    setItems(checklistItems);
  }, [checklistItems]);

  return (
    <>
      <Sortable
        value={items}
        onValueChange={(reorderedItems) => {
          setItems(reorderedItems);
          if (reorderChecklistItems) {
            reorderChecklistItems(reorderedItems);
          }
        }}
        getItemValue={(item) => item.id}
      >
        <SortableContent className="space-y-3">
          {items.map((item) => (
            <SortableItem key={item.id} value={item.id}>
              <ChecklistItemRow item={item} {...uiConfig} />
            </SortableItem>
          ))}
        </SortableContent>
      </Sortable>
      {checklistItems.length === 0 && (
        <div className="flex items-center justify-center h-full min-h-16">
          <p className="text-sm text-muted-foreground">
              No items in this checklist.
          </p>
        </div>
      )}
    </>
  );
};
